// Intrusion alert helper — called when an expert exceeds their search quota.

import { api } from "@/lib/api";

/**
 * Send an intrusion alert to the admin. Fire-and-forget : we don't want the
 * UI to wait for the email to be sent, and we don't want to crash if it fails.
 */
export function sendIntrusionAlert({ username, role, actionCount, description }) {
  try {
    api
      .post("/security/intrusion-alert", {
        username,
        role,
        action_count: actionCount,
        description,
        user_agent: typeof navigator !== "undefined" ? navigator.userAgent : null,
      })
      .catch((e) => {
        // best-effort — telemetry failure must not surface to the user
        console.warn("[security] intrusion alert send failed", e?.message);
      });
  } catch (e) {
    console.warn("[security] intrusion alert builder failed", e?.message);
  }
}
